App.TurbolinksRemoteForm = ({ form, redirectTo }) => {
  if (redirectTo) {
    window.Turbolinks.clearCache();
    window.Turbolinks.visit(redirectTo);
  } else {
    const $form = $(form);
    $(`#${$form.attr('id')}`).replaceWith($form);
  }
};
